import React from 'react'
import Layout from '../../../../../../component/layout/Layout'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

const RapidSheetDryer = () => {
const settings = {
        dots: true,
        infinite: true,
        speed: 1500,        // ✅ slower transition (2 seconds)
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500 // ✅ stays 3 seconds before next slide (optional)
    };

    const images = [
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2Finstruments%2Fpulp%26paper%2Fpaperinstrument%2Fimg%2F1771322954284_Rapid_Sheet_Dryer.png?alt=media&token=eb62e388-1698-44a1-9486-90291c6a30f3',
        'https://firebasestorage.googleapis.com/v0/b/rmcpl-8a920.appspot.com/o/upload%2Finstruments%2Fpulp%26paper%2Fpaperinstrument%2Fimg%2F1771322954284_Rapid_Sheet_Dryer.png?alt=media&token=eb62e388-1698-44a1-9486-90291c6a30f3'
    ];
    return (
        <Layout>
            <div className="bread">
                <ul className="collapsed">
                    <li><a href="/">Home</a></li>
                    <li><a href="/paperTesting">Paper Testing</a></li>
                </ul>
            </div>
            <div className="container">
                <div className="section-title text-center" style={{ marginBottom: '2rem' }}>
                    <h1>Rapid Sheet Dryer</h1>
                </div>
            </div>
            <section id="portfolio-details" className="portfolio-details" style={{ backgroundColor: 'white', marginBottom: '12rem' }}>
                <div className="container">
                    <div className="row gy-4">
                        <div className="col-lg-8">
                            <div className="portfolio-details-slider swiper">
                                <Slider {...settings}>
                                    {images.map((src, index) => (
                                        <div className="swiper-slide" key={index}>
                                            <div className="img" style={{ alignItems: 'center' }}>
                                                <img src={src} alt="" className="responsive" />
                                            </div>
                                        </div>
                                    ))}
                                </Slider>
                                <div className="swiper-pagination"></div>
                            </div>
                        </div>
                        <div className="col-lg-4">
                            <div className="portfolio-info" style={{ backgroundColor: 'white' }}>
                                <h3 className='pageheading'>Rapid Sheet Dryer</h3>
                                <p className='descriptionHead' style={{ textAlign: 'justify' }}>
                                   For fast drying of wet paper pulp sheets mainly from laboratory sheet former according to TAPPI or SCAN standards. The dryer consists of a sturdy stainless-steel bottom with a fitted hot plate and a safety cover. The heating plate can be adjusted to any temperature between room temperature and +180 °C. The plate is heated from below and maintains its temperature with a maximum difference of ± 10 °C. The internal face of the plate is coated with a specific fabric that guarantees the evacuation of steam. The cover provides good compression of the dry matter and prevents excessive heat radiation, minimizing energy consumption.
                                       <br /><br />
                                    <a
                                        href="mailto:inst@rmc.in?subject=Inquiry about Rapid Sheet Dryer"
                                        style={{ color: '#0d6efd', fontWeight: '600', textDecoration: 'underline' }}
                                    >
                                        More Info
                                    </a>
                                </p>
                            </div>
                            <div className="portfolio-description"></div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    )
}

export default RapidSheetDryer